import React, { useState, useMemo } from 'react';

export const NaluriContext = React.createContext({
  isReadAccessOnly: true,
  setAccessLevel: () => {}, // For auto completion purposes only
});

const NaluriContextProvider = props => {
  const [isReadAccessOnly, setIsReadAccessOnly] = useState(true); // To enable or disable read only mode in coach app

  const setAccessLevel = userID => {
    // Set access level to read only if the user is UMMC researcher
    const ummcResearcherUserIDs = process.env.NALURI_APP_UMMC_RESEARCHER_USER_ID.split(',');
    const userIsUMMCResearcher = ummcResearcherUserIDs.findIndex(id => id === userID) !== -1;

    setIsReadAccessOnly(userIsUMMCResearcher);
  };

  const value = useMemo(
    () => ({
      isReadAccessOnly: isReadAccessOnly,
      setAccessLevel: setAccessLevel,
    }),
    [isReadAccessOnly],
  );

  return <NaluriContext.Provider value={value}>{props.children}</NaluriContext.Provider>;
};

export default NaluriContextProvider;



// WEBPACK FOOTER //
// ./src/common/naluri-context.js